import { CommonInput, CommonLabel, FlexBox, INPUT_TYPES, MagicBoxRow, useBreakpoint } from "@brg/ui";
import { BaseSyntheticEvent, forwardRef, useMemo, useRef } from "react";
import { DisplayLinkContainer, GroupsInputsContainer, LegalName } from "../../styles";
import { Switcher } from "./Switcher";
import { BasketIcon } from "shared/pages/projectEdit/BasketIcon";
import { DottedIcon } from "shared/icons/DottedIcon";
import { SortableKnob } from "react-easy-sort";
import { LangObjectArray } from "@brg/api/dist/api-core/utils/lang-utils";
import { FormFieldType } from "../../constants";
import { getAdditionalInfoVal } from "../../support";
import { createDefaultLangObject } from "shared/components/__ADDONS__/__SAFEAPI__/Defaults";
import { useTranslation } from "react-i18next";
import { Lang } from "@brg/api";
import { LabelRedStar } from "shared/modals/competitionLegalsModal/style";
import {ReactComponent as DeleteIcon} from "../../assets/delete.svg";
import { LayoutConst } from "core/modules/layout.module";

interface TdInputProps {
  type: FormFieldType;
  placeholder: LangObjectArray;
  isDisabled: boolean;
  header: LangObjectArray;
  isRequired?: boolean;
  index: number;
  url?: string;
  additionalInfo?: any;
  onChange: (id: any, ev: BaseSyntheticEvent, lang?: string) => void;
  onDeleteField: (index: number) => void;
  onSwitchChange: (index: number, value: number | boolean) => void;
  onRequiredChange: (index: number, value: boolean) => void;
}

export const GroupsInputs = forwardRef<HTMLTableRowElement, TdInputProps>(({
  type,
  index,
  placeholder,
  isDisabled,
  header,
  url,
  additionalInfo,
  isRequired,
  onChange,
  onDeleteField,
  onSwitchChange,
  onRequiredChange
}, ref) => {
  const switcherRef = useRef<any>(null);
  const { i18n: { language }} = useTranslation();
  const isMobile = useBreakpoint(LayoutConst.screen.s-1);

  const { textBefore, textAfter, text } = useMemo(() => {
    return {
      textBefore: getAdditionalInfoVal(additionalInfo, 'textBefore'),
      textAfter: getAdditionalInfoVal(additionalInfo, 'textAfter'),
      text: getAdditionalInfoVal(additionalInfo, 'text'),
    }
  }, [additionalInfo])

  const displayLinkText = useMemo(() => {
    return (
      <DisplayLinkContainer>
            {Lang(textBefore, language)}
            {" "}
            <a href={url} target="_blank" rel="noopener noreferrer">
                {Lang(text, language)}
            </a>
            {" "}
            {Lang(textAfter, language)}
            {<LabelRedStar className="required-label" hide={!isRequired}>*</LabelRedStar>}
        </DisplayLinkContainer>
    )
  }, [textBefore, text, textAfter, language, url, isRequired  ])

  if (isMobile) {
    return (
      <GroupsInputsContainer ref={ref}>
        <FlexBox direction="row" align="center" justify="space-between" style={{ gap: 8 }}>
          <SortableKnob>
            <div style={{ cursor: 'grab', backgroundColor: 'transparent', height: 21, display: 'flex', alignItems: 'center' }}>
              <DottedIcon />
            </div>
          </SortableKnob>
          <LegalName>{Lang(header, language)}</LegalName>
          <div onClick={() => onDeleteField(index)}>
            <DeleteIcon />
          </div>
        </FlexBox>
        <FlexBox direction="row" align="center" justify="space-between" style={{ gap: 8 }}>
          <MagicBoxRow
            checked={isRequired || false}
            label="Обязательное поле"
            onClick={() => onRequiredChange(index, !isRequired)}
          />
          <Switcher
            ref={switcherRef}
            value={isDisabled ? 0 : 1}
            label=""
            onChange={(value: any) => onSwitchChange(index, value)}
          />
        </FlexBox>
        <CommonInput
          type={INPUT_TYPES.text}
          label={'Внутреннее название документа'}
          placeholder={''}
          value={header}
          name={'header'}
          onWhiteBG
          useLangSwitcher
          onChange={(ev: any, lang?: string) => onChange(index, ev, lang)}
        />
        <CommonInput
          type={INPUT_TYPES.text}
          label={'Текст до ссылки'}
          placeholder={''}
          value={textBefore}
          name={'textBefore'}
          onWhiteBG
          useLangSwitcher
          onChange={(ev: any, lang?: string) => {
            const fakeEv: any = {
              target: {
                name: 'textBefore',
                value: ev.target.value
              }
            }

            onChange(index, fakeEv as any, lang)
          }}
        />
        <CommonInput
          type={INPUT_TYPES.text}
          label={'Текст ссылки'}
          placeholder={''}
          value={text}
          name={'text'}
          onWhiteBG
          useLangSwitcher
          onChange={(ev: any, lang?: string) => {
            const fakeEv: any = {
              target: {
                name: 'text',
                value: ev.target.value
              }
            }
            onChange(index, fakeEv as any, lang)
          }}
        />
        <CommonInput
          type={INPUT_TYPES.text}
          label={'Текст после ссылки'}
          placeholder={''}
          value={textAfter}
          name={'textAfter'}
          onWhiteBG
          useLangSwitcher
          onChange={(ev: any, lang?: string) => {
            const fakeEv: any = {
              target: {
                name: 'textAfter',
                value: ev.target.value
              }
            }
            onChange(index, fakeEv as any, lang)
          }}
        />
        <CommonInput
          type={INPUT_TYPES.text}
          label={'Ссылка на документ'}
          placeholder={''}
          value={url}
          name={'url'}
          onWhiteBG
          onChange={(ev: any, lang?: string) => onChange(index, ev, lang)}
        />
        <FlexBox direction="column" >
          <CommonLabel
            label={'Отображение'}
            onWhiteBG
          />
         <FlexBox direction="row" align="center" style={{ gap: 12 }}>
          <MagicBoxRow
              checked={false}
              label=""
              onClick={() => null}
            />
            {displayLinkText}
         </FlexBox>
        </FlexBox>
      </GroupsInputsContainer>
    )
  }

  return (
    <GroupsInputsContainer ref={ref}>
      <FlexBox
        direction="row"
        align="center"
        justify="space-between"
      >
        <FlexBox direction="row" align="center" style={{ gap: 12 }}>
          <SortableKnob>
            <div style={{ cursor: 'grab', backgroundColor: 'transparent', height: 21, display: 'flex', alignItems: 'center' }}>
              <DottedIcon />
            </div>
          </SortableKnob>
          <LegalName>{Lang(header, language)}</LegalName>
        </FlexBox>
        <FlexBox direction="row" align="center" style={{ gap: 24 }}>
          <FlexBox direction="column" align="center" style={{ justifyContent: 'center', minWidth: 28 }}>
            <MagicBoxRow
              checked={isRequired || false}
              label="Обязательное поле"
              onClick={() => onRequiredChange(index, !isRequired)}
            />
          </FlexBox>
          <Switcher
            ref={switcherRef}
            value={isDisabled ? 0 : 1}
            label=""
            onChange={(value: any) => onSwitchChange(index, value)}
          />
          <div onClick={() => onDeleteField(index)}>
            <DeleteIcon />
          </div>
        </FlexBox>
      </FlexBox>
      <FlexBox
        direction="column"
        style={{
          gap: 16,
          width: '100%',
          maxWidth: 800,
        }}
      >
        <CommonInput
          type={INPUT_TYPES.text}
          label={'Внутреннее название документа'}
          placeholder={''}
          value={header}
          name={'header'}
          onWhiteBG
          useLangSwitcher
          onChange={(ev: any, lang?: string) => onChange(index, ev, lang)}
        />
        <CommonInput
          type={INPUT_TYPES.text}
          label={'Текст до ссылки'}
          placeholder={''}
          value={textBefore}
          name={'textBefore'}
          onWhiteBG
          useLangSwitcher
          onChange={(ev: any, lang?: string) => {
            const fakeEv: any = {
              target: {
                name: 'textBefore',
                value: ev.target.value
              }
            }

            onChange(index, fakeEv as any, lang)
          }}
        />
        <CommonInput
          type={INPUT_TYPES.text}
          label={'Текст ссылки'}
          placeholder={''}
          value={text}
          name={'text'}
          onWhiteBG
          useLangSwitcher
          onChange={(ev: any, lang?: string) => {
            const fakeEv: any = {
              target: {
                name: 'text',
                value: ev.target.value
              }
            }
            onChange(index, fakeEv as any, lang)
          }}
        />
        <CommonInput
          type={INPUT_TYPES.text}
          label={'Текст после ссылки'}
          placeholder={''}
          value={textAfter}
          name={'textAfter'}
          onWhiteBG
          useLangSwitcher
          onChange={(ev: any, lang?: string) => {
            const fakeEv: any = {
              target: {
                name: 'textAfter',
                value: ev.target.value
              }
            }
            onChange(index, fakeEv as any, lang)
          }}
        />
        <CommonInput
          type={INPUT_TYPES.text}
          label={'Ссылка на документ'}
          placeholder={''}
          value={url}
          name={'url'}
          onWhiteBG
          onChange={(ev: any, lang?: string) => onChange(index, ev, lang)}
        />
        <FlexBox direction="row" directionMobile="column">
          <CommonLabel
            label={'Отображение'}
            onWhiteBG
          />
         <FlexBox direction="row" align="center" alignMobile="flex-start" style={{ gap: 12 }}>
          <MagicBoxRow
              checked={false}
              label=""
              onClick={() => null}
            />
            {displayLinkText}
         </FlexBox>
        </FlexBox>
      </FlexBox>
    </GroupsInputsContainer>
  );
});

GroupsInputs.displayName = "GroupsInputs";import { CommonInput, CommonLabel, FlexBox, INPUT_TYPES, MagicBoxRow, useBreakpoint } from "@brg/ui";
import { BaseSyntheticEvent, forwardRef, useMemo, useRef } from "react";
import { DisplayLinkContainer, GroupsInputsContainer, LegalName } from "../../styles";
import { Switcher } from "./Switcher";
import { BasketIcon } from "shared/pages/projectEdit/BasketIcon";
import { DottedIcon } from "shared/icons/DottedIcon";
import { SortableKnob } from "react-easy-sort";
import { LangObjectArray } from "@brg/api/dist/api-core/utils/lang-utils";
import { FormFieldType } from "../../constants";
import { getAdditionalInfoVal } from "../../support";
import { createDefaultLangObject } from "shared/components/__ADDONS__/__SAFEAPI__/Defaults";
import { useTranslation } from "react-i18next";
import { Lang } from "@brg/api";
import { LabelRedStar } from "shared/modals/competitionLegalsModal/style";
import {ReactComponent as DeleteIcon} from "../../assets/delete.svg";
import { LayoutConst } from "core/modules/layout.module";

interface TdInputProps {
  type: FormFieldType;
  placeholder: LangObjectArray;
  isDisabled: boolean;
  header: LangObjectArray;
  isRequired?: boolean;
  index: number;
  url?: string;
  additionalInfo?: any;
  onChange: (id: any, ev: BaseSyntheticEvent, lang?: string) => void;
  onDeleteField: (index: number) => void;
  onSwitchChange: (index: number, value: number | boolean) => void;
  onRequiredChange: (index: number, value: boolean) => void;
}

export const GroupsInputs = forwardRef<HTMLTableRowElement, TdInputProps>(({
  type,
  index,
  placeholder,
  isDisabled,
  header,
  url,
  additionalInfo,
  isRequired,
  onChange,
  onDeleteField,
  onSwitchChange,
  onRequiredChange
}, ref) => {
  const switcherRef = useRef<any>(null);
  const { i18n: { language }} = useTranslation();
  const isMobile = useBreakpoint(LayoutConst.screen.s-1);

  const { textBefore, textAfter, text } = useMemo(() => {
    return {
      textBefore: getAdditionalInfoVal(additionalInfo, 'textBefore'),
      textAfter: getAdditionalInfoVal(additionalInfo, 'textAfter'),
      text: getAdditionalInfoVal(additionalInfo, 'text'),
    }
  }, [additionalInfo])

  const displayLinkText = useMemo(() => {
    return (
      <DisplayLinkContainer>
            {Lang(textBefore, language)}
            {" "}
            <a href={url} target="_blank" rel="noopener noreferrer">
                {Lang(text, language)}
            </a>
            {" "}
            {Lang(textAfter, language)}
            {<LabelRedStar className="required-label" hide={!isRequired}>*</LabelRedStar>}
        </DisplayLinkContainer>
    )
  }, [textBefore, text, textAfter, language, url, isRequired  ])

  if (isMobile) {
    return (
      <GroupsInputsContainer ref={ref}>
        <FlexBox direction="row" align="center" justify="space-between" style={{ gap: 8 }}>
          <SortableKnob>
            <div style={{ cursor: 'grab', backgroundColor: 'transparent', height: 21, display: 'flex', alignItems: 'center' }}>
              <DottedIcon />
            </div>
          </SortableKnob>
          <LegalName>{Lang(header, language)}</LegalName>
          <div onClick={() => onDeleteField(index)}>
            <DeleteIcon />
          </div>
        </FlexBox>
        <FlexBox direction="row" align="center" justify="space-between" style={{ gap: 8 }}>
          <MagicBoxRow
            checked={isRequired || false}
            label="Обязательное поле"
            onClick={() => onRequiredChange(index, !isRequired)}
          />
          <Switcher
            ref={switcherRef}
            value={isDisabled ? 0 : 1}
            label=""
            onChange={(value: any) => onSwitchChange(index, value)}
          />
        </FlexBox>
        <CommonInput
          type={INPUT_TYPES.text}
          label={'Внутреннее название документа'}
          placeholder={''}
          value={header}
          name={'header'}
          onWhiteBG
          useLangSwitcher
          onChange={(ev: any, lang?: string) => onChange(index, ev, lang)}
        />
        <CommonInput
          type={INPUT_TYPES.text}
          label={'Текст до ссылки'}
          placeholder={''}
          value={textBefore}
          name={'textBefore'}
          onWhiteBG
          useLangSwitcher
          onChange={(ev: any, lang?: string) => {
            const fakeEv: any = {
              target: {
                name: 'textBefore',
                value: ev.target.value
              }
            }

            onChange(index, fakeEv as any, lang)
          }}
        />
        <CommonInput
          type={INPUT_TYPES.text}
          label={'Текст ссылки'}
          placeholder={''}
          value={text}
          name={'text'}
          onWhiteBG
          useLangSwitcher
          onChange={(ev: any, lang?: string) => {
            const fakeEv: any = {
              target: {
                name: 'text',
                value: ev.target.value
              }
            }
            onChange(index, fakeEv as any, lang)
          }}
        />
        <CommonInput
          type={INPUT_TYPES.text}
          label={'Текст после ссылки'}
          placeholder={''}
          value={textAfter}
          name={'textAfter'}
          onWhiteBG
          useLangSwitcher
          onChange={(ev: any, lang?: string) => {
            const fakeEv: any = {
              target: {
                name: 'textAfter',
                value: ev.target.value
              }
            }
            onChange(index, fakeEv as any, lang)
          }}
        />
        <CommonInput
          type={INPUT_TYPES.text}
          label={'Ссылка на документ'}
          placeholder={''}
          value={url}
          name={'url'}
          onWhiteBG
          onChange={(ev: any, lang?: string) => onChange(index, ev, lang)}
        />
        <FlexBox direction="column" >
          <CommonLabel
            label={'Отображение'}
            onWhiteBG
          />
         <FlexBox direction="row" align="center" style={{ gap: 12 }}>
          <MagicBoxRow
              checked={false}
              label=""
              onClick={() => null}
            />
            {displayLinkText}
         </FlexBox>
        </FlexBox>
      </GroupsInputsContainer>
    )
  }

  return (
    <GroupsInputsContainer ref={ref}>
      <FlexBox
        direction="row"
        align="center"
        justify="space-between"
      >
        <FlexBox direction="row" align="center" style={{ gap: 12 }}>
          <SortableKnob>
            <div style={{ cursor: 'grab', backgroundColor: 'transparent', height: 21, display: 'flex', alignItems: 'center' }}>
              <DottedIcon />
            </div>
          </SortableKnob>
          <LegalName>{Lang(header, language)}</LegalName>
        </FlexBox>
        <FlexBox direction="row" align="center" style={{ gap: 24 }}>
          <FlexBox direction="column" align="center" style={{ justifyContent: 'center', minWidth: 28 }}>
            <MagicBoxRow
              checked={isRequired || false}
              label="Обязательное поле"
              onClick={() => onRequiredChange(index, !isRequired)}
            />
          </FlexBox>
          <Switcher
            ref={switcherRef}
            value={isDisabled ? 0 : 1}
            label=""
            onChange={(value: any) => onSwitchChange(index, value)}
          />
          <div onClick={() => onDeleteField(index)}>
            <DeleteIcon />
          </div>
        </FlexBox>
      </FlexBox>
      <FlexBox
        direction="column"
        style={{
          gap: 16,
          width: '100%',
          maxWidth: 800,
        }}
      >
        <CommonInput
          type={INPUT_TYPES.text}
          label={'Внутреннее название документа'}
          placeholder={''}
          value={header}
          name={'header'}
          onWhiteBG
          useLangSwitcher
          onChange={(ev: any, lang?: string) => onChange(index, ev, lang)}
        />
        <CommonInput
          type={INPUT_TYPES.text}
          label={'Текст до ссылки'}
          placeholder={''}
          value={textBefore}
          name={'textBefore'}
          onWhiteBG
          useLangSwitcher
          onChange={(ev: any, lang?: string) => {
            const fakeEv: any = {
              target: {
                name: 'textBefore',
                value: ev.target.value
              }
            }

            onChange(index, fakeEv as any, lang)
          }}
        />
        <CommonInput
          type={INPUT_TYPES.text}
          label={'Текст ссылки'}
          placeholder={''}
          value={text}
          name={'text'}
          onWhiteBG
          useLangSwitcher
          onChange={(ev: any, lang?: string) => {
            const fakeEv: any = {
              target: {
                name: 'text',
                value: ev.target.value
              }
            }
            onChange(index, fakeEv as any, lang)
          }}
        />
        <CommonInput
          type={INPUT_TYPES.text}
          label={'Текст после ссылки'}
          placeholder={''}
          value={textAfter}
          name={'textAfter'}
          onWhiteBG
          useLangSwitcher
          onChange={(ev: any, lang?: string) => {
            const fakeEv: any = {
              target: {
                name: 'textAfter',
                value: ev.target.value
              }
            }
            onChange(index, fakeEv as any, lang)
          }}
        />
        <CommonInput
          type={INPUT_TYPES.text}
          label={'Ссылка на документ'}
          placeholder={''}
          value={url}
          name={'url'}
          onWhiteBG
          onChange={(ev: any, lang?: string) => onChange(index, ev, lang)}
        />
        <FlexBox direction="row" directionMobile="column">
          <CommonLabel
            label={'Отображение'}
            onWhiteBG
          />
         <FlexBox direction="row" align="center" alignMobile="flex-start" style={{ gap: 12 }}>
          <MagicBoxRow
              checked={false}
              label=""
              onClick={() => null}
            />
            {displayLinkText}
         </FlexBox>
        </FlexBox>
      </FlexBox>
    </GroupsInputsContainer>
  );
});

GroupsInputs.displayName = "GroupsInputs";